import { redactString, type ClientErrorLocation } from '@neon-one/frontend-observability';

import { env } from '@/shell/env';

const SOURCE = 'admin-web';

export function reportError(err: Error, info?: string, location?: ClientErrorLocation): void {
  if (!env.clientErrorReporting) return;
  const payload = {
    message: redactString(err.message).slice(0, 2048),
    stack: err.stack ? redactString(err.stack).slice(0, 8192) : undefined,
    info: info ? redactString(info).slice(0, 2048) : undefined,
    // Sent on `!== undefined`, NOT on truthiness. An empty file with line and
    // column at 0 is the browser declining to disclose a cross-origin error,
    // and that is the single field that separates "an extension threw, ignore
    // it" from "our own code threw and the handler could not unwrap it".
    // Dropping it as falsy would discard the reason it is here.
    file: location?.file !== undefined ? redactString(location.file).slice(0, 2048) : undefined,
    line: location?.line,
    column: location?.column,
    url: typeof window !== 'undefined' ? `${window.location.origin}${window.location.pathname}`.slice(0, 2048) : undefined,
    source: SOURCE,
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : undefined,
    timestamp: new Date().toISOString(),
  };
  fetch(`${env.apiBaseUrl}/client-errors`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {});
}
